// src/components/ui/switch.jsx
import React, { useState, useEffect } from 'react';

const Switch = React.forwardRef(({ 
  className = '', 
  checked: controlledChecked,
  defaultChecked = false,
  onCheckedChange,
  disabled = false,
  ...props 
}, ref) => {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  
  // Determinar si es controlado o no controlado
  const isControlled = controlledChecked !== undefined;
  const checked = isControlled ? controlledChecked : internalChecked;

  useEffect(() => {
    if (isControlled) {
      setInternalChecked(controlledChecked);
    }
  }, [controlledChecked, isControlled]);

  const handleToggle = () => {
    if (disabled) return;
    
    const newChecked = !checked;
    
    if (!isControlled) {
      setInternalChecked(newChecked);
    }
    
    if (onCheckedChange) {
      onCheckedChange(newChecked);
    }
  };

  const baseClasses = `
    relative inline-flex h-6 w-11 items-center rounded-full
    transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
    cursor-pointer
  `;

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';
  const bgClasses = checked 
    ? 'bg-blue-600' 
    : 'bg-gray-200';

  const thumbClasses = `
    inline-block h-4 w-4 transform rounded-full bg-white transition-transform
    ${checked ? 'translate-x-6' : 'translate-x-1'}
  `;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      ref={ref}
      onClick={handleToggle}
      disabled={disabled}
      className={`${baseClasses} ${bgClasses} ${disabledClasses} ${className}`.trim()}
      {...props}
    >
      <span className={thumbClasses} />
    </button>
  );
});

Switch.displayName = 'Switch';

export { Switch };